import classNames from "classnames";
import { FC, ReactNode } from "react";
import Icon from "~/components/Icon";
import { IconNames } from "~/components/Icon/Icon.type";
import Text from "~/components/Text";

interface AuthMessageProps {
  title?: string;
  icon?: { name: IconNames; color?: string };
  children?: ReactNode;
  className?: string;
}

const AuthMessage: FC<AuthMessageProps> = ({
  title,
  icon,
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        "max-w-[480px] px-4 m-auto flex flex-col items-center gap-4",
        className
      )}
    >
      <Icon name={icon?.name} size={64} color={icon?.color} />
      <Text type="title-1" className="text-center">
        {title}
      </Text>
      {children}
    </div>
  );
};

export default AuthMessage;
